import { render, staticRenderFns } from "./InvProductTable.vue?vue&type=template&id=56189c7f&scoped=true"
import script from "./InvProductTable.vue?vue&type=script&lang=js"
export * from "./InvProductTable.vue?vue&type=script&lang=js"
import style0 from "./InvProductTable.vue?vue&type=style&index=0&id=56189c7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56189c7f",
  null
  
)

export default component.exports